export default __webpack_public_path__ + "static/media/10.bd41266e.jpeg";